
const SECRET_KEY = process.env.REACT_APP_SECRET;

const encoder = new TextEncoder();
const decoder = new TextDecoder();

const getKey = async () => {
  const keyMaterial = await window.crypto.subtle.importKey(
    "raw",
    encoder.encode(SECRET_KEY),
    "PBKDF2",
    false,
    ["deriveKey"]
  );

  return window.crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: encoder.encode("salt-value"),
      iterations: 100000,
      hash: "SHA-256",
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"]
  );
};

const base64Encode = (buffer) =>
  btoa(String.fromCharCode(...new Uint8Array(buffer)));

const base64Decode = (base64) =>
  Uint8Array.from(atob(base64), c => c.charCodeAt(0));

export const encryptAndStoreTimestamp = async () => {
  const timestamp = new Date().toISOString();
  const key = await getKey();
  const iv = window.crypto.getRandomValues(new Uint8Array(12));

  const encryptedBuffer = await window.crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encoder.encode(timestamp)
  );

  const encryptedString = `${base64Encode(iv)}.${base64Encode(encryptedBuffer)}`;

  localStorage.setItem("encryptedTimestamp", encryptedString);
};
